import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-locize-backend'
import locizeLastUsed from 'locize-lastused'

const projectId = process.env.REACT_APP_LOCIZE_PROJECT_ID as string
const apiKey = process.env.REACT_APP_LOCIZE_API_KEY

const locizeOptions = {
  projectId,
  apiKey,
  referenceLng: 'de-DE',
  allowedAddOrUpdateHosts: ['localhost'],
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(locizeLastUsed)
  .init({
    locizeLastUsed: {
      projectId,
    },
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'de-DE',
    saveMissing: true,
    interpolation: {
      escapeValue: false,
    },
    backend: locizeOptions,
  })

export default i18n
